import React from 'react';
import { useTranslation } from 'react-i18next';
import { SPECIALTIES } from '../../../lib/data/medicalPresets';

// Dropdown de especialidades de salud comunes en AR (Consultame, NER-3832).
// Al elegir "otro" se habilita un campo de texto libre. Emite el cambio como
// { specialty, specialtyOther } para que el wizard actualice el estado.
function SpecialtyPicker({ value, otherValue, onChange, error }) {
  const { t } = useTranslation();

  const handleSelect = (specialty) => {
    onChange({ specialty, specialtyOther: specialty === 'otro' ? otherValue || '' : '' });
  };

  return (
    <div className="med-field">
      <label className="med-label" htmlFor="specialty-picker">
        {t('setupWizardMedical.professional.specialty', 'Especialidad')}
      </label>
      <select
        id="specialty-picker"
        className="sw-input"
        value={value || ''}
        onChange={(e) => handleSelect(e.target.value)}
      >
        <option value="" disabled>
          {t('setupWizardMedical.professional.specialtyPlaceholder', 'Elegí una especialidad')}
        </option>
        {SPECIALTIES.map((s) => (
          <option key={s.key} value={s.key}>
            {t(`setupWizardMedical.specialties.${s.key}`, s.label)}
          </option>
        ))}
      </select>

      {value === 'otro' && (
        <input
          type="text"
          className="sw-input med-field-spaced"
          value={otherValue || ''}
          onChange={(e) => onChange({ specialty: 'otro', specialtyOther: e.target.value })}
          placeholder={t('setupWizardMedical.professional.specialtyOther', 'Especificá tu especialidad')}
        />
      )}

      {error && (
        <p className="sw-error">
          {t('setupWizardMedical.errors.specialtyRequired', 'Elegí tu especialidad')}
        </p>
      )}
    </div>
  );
}

export default SpecialtyPicker;
